/**
 *
 * @param {jQuery} wrapper
 *
 * 裁剪效果的同步。
 *     包括：设置弹窗预览小窗同步，时间轴预览小窗同步，路径动画同步
 */
function handleCrop (wrapper, sprite) {
  sprite = sprite || this.sprite;
  let cropBoxData = (sprite || {}).cropBoxData;
  if (!cropBoxData || sprite.cropType !== 'free') {
    return;
  }

  if (!(wrapper instanceof $)) {
    wrapper = $(wrapper);
  }

  let image = wrapper.children().eq(0);

  let nextW = wrapper.width();
  let nextH = wrapper.height();
  let ratioH = nextH / cropBoxData.height;
  let ratioW = nextW / cropBoxData.width;
  let nextCrop = {
      width: nextW,
      height: nextH,
      top: cropBoxData.top * ratioH,
      left: cropBoxData.left * ratioW,
      originWidth: cropBoxData.originWidth * ratioW,
      originHeight: cropBoxData.originHeight * ratioH,
      deltaX: cropBoxData.deltaX * ratioW,
      deltaY: cropBoxData.deltaY * ratioH,
      rotation: cropBoxData.rotation,
      deltaRotation: cropBoxData.deltaRotation,
      innerRotation: cropBoxData.innerRotation
  };

  wrapper.css({
    position: 'relative',
    width: nextW,
    height: nextH,
    overflow: 'hidden'
  });

  image.hide();
  this.setCropContent(nextCrop, wrapper, sprite);
}

/**
 * 设置裁剪框中的截图
 * @param {Object} cropBoxData 裁剪图片的信息
 * @param {jQuery} container 图片容器
 */
function setCropContent (cropBoxData, container, sprite) {
  container.find('.crop-inner-ref').remove();
  var innerRef = $('<div></div>');
  innerRef.addClass('crop-inner-ref');
  innerRef.css({
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: 0,
      height: 0
  });
  var innerImageWrapper = $('<div></div>');
  innerImageWrapper.css({
      position: 'absolute',
      left: cropBoxData.deltaX || 0,
      top: cropBoxData.deltaY || 0,
      width: 0,
      height: 0
  });
  var innerImageEl = $('<img/>');
  innerImageEl.prop('src', this.$handleAssetsUrl(sprite.option.url));
  innerImageEl.css({
      width: cropBoxData.originWidth,
      height: cropBoxData.originHeight,
      maxWidth: cropBoxData.originWidth,
      transform: 'translate(-50%, -50%) rotate(' + cropBoxData.deltaRotation + 'deg)'
  });

  innerImageWrapper.append(innerImageEl);
  innerRef.append(innerImageWrapper);
  container.append(innerRef);
}

export default {
  methods: {
    handleCrop,
    resizeWrapper (el, sprite, len = 26) {
      let cropBoxData = (sprite || {}).cropBoxData;
      let jqEl = $(el);
      if (!cropBoxData || sprite.cropType !== 'free') {
        jqEl.css({
          display: '',
          width: '100%',
          height: '100%'
        });
        return;
      }

      let isHorizontal = sprite.width >= sprite.height;
      let whRatio = sprite.width / sprite.height;
      jqEl.css({
        display: 'block'
      });
      if (isHorizontal) {
        jqEl.css({
          width: len,
          height: len / whRatio
        })
      } else {
        jqEl.css({
          width: len * whRatio,
          height: len
        })
      }
    },
    scaleWrapper (el) {
      $(el).css({
        transform: `scalex(0.1) scaley(0.1)`
      })
    },
    setCropContent,
    hideFourPoints (wrapper, sprite) {
      let points = $(wrapper).find('.op-handle-n, .op-handle-e, .op-handle-s, .op-handle-w');
      if (sprite.cropBoxData && Math.abs(sprite.cropBoxData.deltaRotation) > 1) {
        points.hide();
      }
      else {
        points.show();
      }
    },
    handleCropLite (wrapper, sprite, img) {
      sprite = sprite || this.sprite;
      let cropBoxData = (sprite || {}).cropBoxData;
      if (!cropBoxData || sprite.cropType !== 'free') {
        return;
      }

      img = img || wrapper.children().eq(0);
      img.show();
      wrapper.find('.crop-inner-ref').remove();

      let nextW = wrapper.width();
      let nextH = wrapper.height();
      let ratioH = nextH / cropBoxData.height;
      let ratioW = nextW / cropBoxData.width;
      let nextCrop = {
          width: nextW,
          height: nextH,
          top: cropBoxData.top * ratioH,
          left: cropBoxData.left * ratioW,
          originWidth: cropBoxData.originWidth * ratioW,
          originHeight: cropBoxData.originHeight * ratioH,
          deltaX: cropBoxData.deltaX * ratioW,
          deltaY: cropBoxData.deltaY * ratioH,
          rotation: cropBoxData.rotation,
          deltaRotation: cropBoxData.deltaRotation,
          innerRotation: cropBoxData.innerRotation
      };

      wrapper.css({
        position: 'relative',
        width: nextW,
        height: nextH,
        overflow: 'hidden'
      });

      img.css({
        position: 'absolute',
        left: nextW / 2 + nextCrop.deltaX - nextCrop.originWidth / 2,
        top: nextH / 2 + nextCrop.deltaY - nextCrop.originHeight / 2,
        width: nextCrop.originWidth,
        height: nextCrop.originHeight,
        maxWidth: nextCrop.originWidth,
        transform: 'rotate(' + nextCrop.deltaRotation + 'deg)'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/handleCrop.js